export default __webpack_public_path__ + "static/media/login.4bf4488e.jpg";